"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

require("./ProgressBar.scss");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = require("react-bootstrap");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProgressBar = function ProgressBar(props) {
  var show = props.show;


  var content = void 0;
  if (show) {
    content = _react2.default.createElement(_reactBootstrap.ProgressBar, { active: true, now: 100 });
  }

  return _react2.default.createElement(
    "div",
    { className: "erg-components-ProgressBar" },
    content
  );
};

ProgressBar.displayName = "ProgressBar";

ProgressBar.propTypes = {
  show: _propTypes2.default.bool.isRequired
};

exports.default = ProgressBar;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@ergeon/erg-components-react/lib/table/ProgressBar.js
 ** module id = 798
 ** module chunks = 0
 **/